import { FilterOptions } from "@/types/FilterOptions";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Checkbox } from "@components/ui/checkbox";
import {
  CommandGroup,
  CommandItem,
  CommandSeparator,
} from "@components/ui/command";
import { Trans } from "@lingui/react/macro";
import { ChevronLeftIcon } from "lucide-react";

export default function PageLanguages({
  options,
  onChange,
  value,
  onBack,
}: {
  onChange: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["language"];
  options: FilterOptions["filter_languages"];
  onBack?: () => void;
}) {
  // Helpers
  const isArray = Array.isArray(value);

  const isAllSelected = isArray && value.length === options.length;

  return (
    <>
      {onBack && (
        <>
          <CommandGroup>
            <CommandItem onSelect={onBack}>
              <ChevronLeftIcon />
              <Trans>Tillbaka</Trans>
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />
        </>
      )}

      {options.length > 1 ? (
        <>
          <CommandGroup>
            {isAllSelected ? (
              <CommandItem
                onSelect={() => {
                  onChange({
                    language: undefined,
                  });
                }}
              >
                <Trans>Avmarkera alla</Trans>
              </CommandItem>
            ) : (
              <CommandItem
                onSelect={() => {
                  onChange({
                    language: options.map(([value]) => value),
                  });
                }}
              >
                <Trans>Markera alla</Trans>
              </CommandItem>
            )}
          </CommandGroup>

          <CommandSeparator />
        </>
      ) : null}

      {options.length ? (
        <CommandGroup>
          {options.map(([language, label]) => {
            const isChecked = isArray
              ? value.includes(language)
              : value === language;

            return (
              <CommandItem
                data-filter-value={language}
                key={language}
                onSelect={() => {
                  if (isChecked) {
                    onChange({
                      language: isArray
                        ? value.filter((it) => it !== language)
                        : undefined,
                    });
                  } else {
                    onChange({
                      language: isArray
                        ? [...value, language]
                        : value
                          ? [value, language]
                          : [language],
                    });
                  }
                }}
              >
                <Checkbox checked={isChecked} className="pointer-events-none" />
                {label}
              </CommandItem>
            );
          })}
        </CommandGroup>
      ) : null}
    </>
  );
}
